import React, { Component } from "react";
import Layout from "../base/Layout";
import LastNewsTable from "../last-news/LastNewsTable";
import { Pagination } from "@material-ui/lab";
import AddNewsModal from "../modals/AddNewsModal";
import ConfirmDeleteModal from "../modals/ConfirmDeleteModal";
import EditNewsModal from "../modals/EditNewsModal";
import { connect } from "react-redux";
import { handleReceiveNews, handleDeleteNews, handlePaginateNews } from "../../actions/news";

class LastNews extends Component {
  state = {
    openAddDialog: false,
    openDeleteDialog: false,
    deleteId: null,
    openEditDialog: false,
    editId: null,
    pagination: {
      per_page: 15,
      current_page: 1,
      last_page: 1,
    },
    paginationDisabled: false,
  };
  handleOpenAddDialog = () => {
    this.setState({ openAddDialog: true });
  };
  handleCloseAddDialog = () => {
    this.setState({ openAddDialog: false });
  };
  handleOpenDeleteDialog = (id) => {
    this.setState({ openDeleteDialog: true, deleteId: id });
  };
  handleCloseDeleteDialog = () => {
    this.setState({ openDeleteDialog: false, deleteId: null });
  };
  handleOpenEditDialog = (id) => {
    this.setState({ openEditDialog: true, editId: id });
  };
  handleCloseEditDialog = () => {
    this.setState({ openEditDialog: false, editId: null });
  };

  handleConfirmDelete = () => {
    const { deleteNews } = this.props;
    const { deleteId } = this.state;
    deleteNews(deleteId);
  };

  handlePaginationChange = (e, current_page) => {
    const { last_page } = this.state.pagination;
    const { getNewsPagination } = this.props;
    if (last_page >= current_page) {
      this.setState({ paginationDisabled: true });
      getNewsPagination(current_page).then(() => {
        this.setState((prevState) => ({
          pagination: { ...prevState.pagination, current_page },
          paginationDisabled: false,
        }));
      });
    }
  };

  componentDidMount() {
    const { getNews } = this.props;
    getNews().then((res) => {
      if (res) {
        const {
          meta: { per_page, current_page, last_page },
        } = res;
        this.setState({
          pagination: {
            per_page,
            current_page,
            last_page,
          },
        });
      }
    });
  }

  render() {
    const {
      openAddDialog,
      openDeleteDialog,
      openEditDialog,
      editId,
      pagination: { current_page, last_page, per_page },
      paginationDisabled,
    } = this.state;
    const {
      news,
      user: { permissions, is_super_admin },
    } = this.props;
    const paginatedNews =
      news.length >= current_page * per_page
        ? news.slice((current_page - 1) * per_page, current_page * per_page - 1)
        : news.slice(-per_page);

    return (
      <Layout
        title="آخر الأخبار"
        addBtnText="إضافة خبر جديد"
        showAddBtn={is_super_admin || permissions.includes(14)}
        handleBtnClicked={this.handleOpenAddDialog}
      >
        <LastNewsTable
          handleEditItem={this.handleOpenEditDialog}
          handleDeleteItem={this.handleOpenDeleteDialog}
          news={news}
          pagination={this.state.pagination}
        />
        {news && (
          <div className="my-3 d-flex justify-content-center align-items-center flex-grow-1">
            <Pagination
              variant="outlined"
              shape="rounded"
              count={last_page}
              page={current_page}
              boundaryCount={2}
              onChange={this.handlePaginationChange}
              disabled={paginationDisabled}
            />
          </div>
        )}
        {is_super_admin || permissions.includes(14) ? (
          <AddNewsModal open={openAddDialog} handleClose={this.handleCloseAddDialog} />
        ) : (
          ""
        )}

        <EditNewsModal open={openEditDialog} handleClose={this.handleCloseEditDialog} editId={editId} />
        <ConfirmDeleteModal
          open={openDeleteDialog}
          handleClose={this.handleCloseDeleteDialog}
          text="هل تريد حذف الخبر؟"
          handleDelete={this.handleConfirmDelete}
        />
      </Layout>
    );
  }
}

const mapStateToProps = ({ news, user }) => ({ news, user });

const mapDispatchToProps = (dispatch) => ({
  getNews: () => dispatch(handleReceiveNews()),
  deleteNews: (id) => dispatch(handleDeleteNews(id)),
  getNewsPagination: (page) => dispatch(handlePaginateNews(page)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LastNews);
